<template>
  <template-list :type="'publisher'" :columnsData="columnsData" />
</template>
<script>
import TemplateList from '../layout/TemplateList';
import store from '../../store/index';

export default {
  name: 'publisher-list',
  components: {
    TemplateList,
  },
  data() {
    return {
      columnsData: [
        'title',
        'original_oem',
        'frame_type',
        'model',
        'part_number',
        'customer',
        'project_number',
        'serial_number',
        'work_order_number',
        'sales_force_opportunity_number',
        'executing_site',
      ],
      prevRoute: null,
    };
  },
  async beforeRouteEnter({}, from, next) {
    const { state } = store;

    const urlPathSplitted = from.path.split('/');

    if (urlPathSplitted.length === 4) {
      const jobId = urlPathSplitted[3];
      if (jobId && jobId !== 'create') {
        await store.dispatch('processJobChanges', jobId);
      }
    }

    state.job = null;

    next((vm) => {
      vm.prevRoute = from;
    });
  },
};
</script>
